import { ResultSquare } from "./ResultSquares";
export default ResultSquare;
